import { Dialog } from '@mui/material';
import AppSpacer from './AppSpacer';

export const AppDialog = ({
  title,
  isOpened,
  onClose,
  children,
  classNames = '',
  maxWidth = 'md',
}: {
  title: string;
  onClose: () => void;
  isOpened: boolean;
  children: React.ReactNode;
  classNames?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}) => {
  return (
    <Dialog
      maxWidth={maxWidth}
      fullWidth
      className={`app-dialog ${classNames}`}
      open={isOpened}
      onClose={() => onClose()}
      data-test='service-dialog'
    >
      <div className='d-flex flex-column h-100'>
        <header className='border-0 mb-0  text-center text-white'>
          <h3 className='font-22 font-500 text-uppercase mb-0 text-uppercase font-22 font-500'>{title}</h3>
        </header>
        <AppSpacer space='24px' />
        {children}
      </div>
    </Dialog>
  );
};

export default AppDialog;
